import React, { useState, useEffect } from 'react';
import './esqueci_senha.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';





function EsqueciSenha() {



  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isDefaultPasswordFlow, setIsDefaultPasswordFlow] = useState(false);



  const navigate = useNavigate();
  const location = useLocation();





  useEffect(() => {
    



    const params = new URLSearchParams(location.search);
    



    let hasDefaultPassword = false;
    let emailFromUrl = '';
    



    if (params.has('defaultpassword')) {


      hasDefaultPassword = true;
      const defaultPasswordValue = params.get('defaultpassword');
      

      if (defaultPasswordValue && defaultPasswordValue.startsWith('?email=')) {

        const malformedParams = new URLSearchParams(defaultPasswordValue.substring(1)); 
        emailFromUrl = malformedParams.get('email') || '';

      } 
      
      
      else {
        emailFromUrl = params.get('email') || '';
      }



    }
    

    if (!hasDefaultPassword && location.search.includes('defaultpassword')) {
      hasDefaultPassword = true;
      

      const searchStr = location.search;
      const emailMatch = searchStr.match(/email=([^&]*)/);



      if (emailMatch) {
        emailFromUrl = decodeURIComponent(emailMatch[1]);
      }




    }
    
    if (hasDefaultPassword) {


      setIsDefaultPasswordFlow(true);

      if (emailFromUrl && emailFromUrl.trim() !== '') {
        setEmail(emailFromUrl);
        console.log(`Email extracted from defaultpassword URL: ${emailFromUrl}`);
      }


      const redirect = params.get('redirect') || '/disciplinas';
      localStorage.setItem('redirectAfterLogin', redirect);
      

      const newSearchParams = new URLSearchParams();
      

      params.forEach((value, key) => {
        if (key !== 'defaultpassword') {
          newSearchParams.append(key, value);
        }
      });
      
      const newUrl = window.location.pathname + (newSearchParams.toString() ? `?${newSearchParams.toString()}` : '');
      window.history.replaceState({}, '', newUrl);
    }


  }, [location, isEmailSent, navigate]);







  const handlePasswordReset = async (e) => {
    
    
    
    e.preventDefault();
    console.log('isDefaultPasswordFlow:', isDefaultPasswordFlow);
    console.log('email:', email);




    try {


      const action = isDefaultPasswordFlow 
        ? 'enviarEmailAutenticacao' 
        : 'enviarEmailRedefinicaoSenha';

    
      // checa se há algo no localStorage falando que tem que redirecionar  
      const redirect = localStorage.getItem('redirectAfterLogin') || '/disciplinas';


      // envia o parâmetro de redirecionamento no email
      const url = `https://rvensino.com.br/get.php?action=${action}&email=${encodeURIComponent(email)}&redirect=${encodeURIComponent(redirect)}`;
      console.log('URL:', url);
      
      
      
      const response = await fetch(url);





      const textResponse = await response.text(); 
      console.log('Raw response:', textResponse);

      let data;

      try {
        // Tenta parsear a resposta como JSON
        data = JSON.parse(textResponse);
      } catch (error) {
        console.warn('Resposta não é um JSON válido. Usando texto bruto.');
        data = { message: textResponse }; // Trata o texto bruto como uma mensagem
      }

      // Exibe a mensagem retornada no campo "message"
      if (data?.status === 0) {
        setMessage(data.message);
        setIsEmailSent(true);
        localStorage.setItem('prefillEmail', email);
      } else {
        setMessage(data.message || data.error || 'Erro desconhecido. Contate o suporte.');
      }
    } catch (error) {
      console.error('Erro ao enviar email de recuperação:', error);
      setMessage('Um erro ocorreu. Tente novamente mais tarde.');
    }
  };






  return (
    <div className="page-container login">
      <div className="login-container">
        <form onSubmit={handlePasswordReset} className='form-forgot-password'>
          <div className="arrow-back cadastro">
            <Link to="/login" className="no-link-style">
              <ArrowBackOutlinedIcon style={{ color: '#000', fontSize: 35 }} className='sidebar-icon custom-arrow-icon' />
            </Link>
          </div>
          <Link to="/login" className="no-link-style">
            <img src="https://rveducacao.com.br/230616_RV_logo_principal_positivo-cor.png" alt="Logo" className="login-logo" />
          </Link>
          
          {!isDefaultPasswordFlow ? (
            // Normal forgot password flow - show email input
            <>
              <input
                type="text"
                placeholder="Email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="button" type="submit">
                Enviar email de recuperação
              </button>
            </>
          ) : (
            // Default password flow - hide input, show confirmation message
            <>
              {/* <p className="default-password-message">
                Um email de confirmação será enviado para: <strong>{email}</strong>
              </p> */}
              <button className="button confirmacao" type="submit">
                Enviar email de confirmação
              </button>
            </>
          )}
          
          {message && <p className="message">{message}</p>}
        </form>
      </div>
    </div>
  );
}









export default EsqueciSenha;
